import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, LogOut, LayoutDashboard } from "lucide-react";
import { LOGO, NAV_ICON } from "@/lib/brand";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const links = [
  { label: "Programs", href: "/#programs" },
  { label: "Events", href: "/#events" },
  { label: "News", href: "/#news" },
  { label: "Gallery", href: "/#gallery" },
  { label: "About", href: "/#about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-brand-black/90 backdrop-blur-md border-b border-white/10" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <button type="button" onClick={() => { navigate("/"); window.scrollTo({ top: 0, behavior: "smooth" }); }} className="flex items-center group" data-testid="nav-logo">
          <img src={NAV_ICON} alt="Lansdowne RFC New York Youth Rugby Club" className="h-14 w-auto object-contain" />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="text-sm font-semibold text-white/80 hover:text-brand-gold transition-colors" data-testid={`nav-${l.label.toLowerCase()}`}>
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user && ["admin", "coach"].includes(user.role) && (
            <Button variant="ghost" className="text-white hover:text-brand-gold hover:bg-white/5 rounded-none" onClick={() => navigate("/admin")} data-testid="nav-admin-btn">
              <LayoutDashboard className="h-4 w-4 mr-2" /> Dashboard
            </Button>
          )}
          {user ? (
            <Button variant="outline" className="rounded-none border-white/20 text-white bg-transparent hover:bg-white/10" onClick={logout} data-testid="nav-logout-btn">
              <LogOut className="h-4 w-4 mr-2" /> Logout
            </Button>
          ) : (
            <Button variant="ghost" className="text-white hover:text-brand-gold hover:bg-white/5 rounded-none" onClick={() => navigate("/login")} data-testid="nav-login-btn">
              Sign In
            </Button>
          )}
          <Button className="bg-brand-red hover:bg-brand-red/90 text-white rounded-none font-bold uppercase tracking-wider" onClick={() => navigate("/register")} data-testid="nav-register-btn">
            Register
          </Button>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-brand-black border-t border-white/10 px-5 py-4 space-y-3" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block text-white/80 font-semibold py-1">{l.label}</a>
          ))}
          {user && ["admin", "coach"].includes(user.role) && (
            <button className="block text-white font-semibold py-1" onClick={() => { navigate("/admin"); setOpen(false); }}>Dashboard</button>
          )}
          {user ? (
            <button className="block text-white font-semibold py-1" onClick={() => { logout(); setOpen(false); }}>Logout</button>
          ) : (
            <button className="block text-white font-semibold py-1" onClick={() => { navigate("/login"); setOpen(false); }}>Sign In</button>
          )}
          <Button className="w-full bg-brand-red text-white rounded-none font-bold uppercase" onClick={() => { navigate("/register"); setOpen(false); }}>Register</Button>
        </div>
      )}
    </header>
  );
}
